import script from "./NewContract.vue?vue&type=script&setup=true&lang=js"
export * from "./NewContract.vue?vue&type=script&setup=true&lang=js"

import "./NewContract.vue?vue&type=style&index=0&id=0fc78932&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc78932"]])

export default __exports__